import React, { lazy, Suspense } from 'react';
var AnalyticsDashboard = lazy(function () {
  return import('./AnalyticsDashboard');
});

var renderLoader = function renderLoader() {
  return React.createElement("p", null, "Loading...");
};
/**
 * @param {import('./types').AnalyticsDashboardProps} props
 */


var AnalyticsDashboardLazy = function AnalyticsDashboardLazy(props) {
  return React.createElement(Suspense, {
    fallback: renderLoader()
  }, React.createElement(AnalyticsDashboard, props));
};

export default AnalyticsDashboardLazy;